import React from 'react';

const TimelineMerchantIcon = ({ fill = 'grey' }) => {
  return (
    <svg
      version="1.1"
      id="Layer_1"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      x="0px"
      y="0px"
      viewBox="0 0 13 14.6"
      xmlSpace="preserve"
      className="card-icon"
    >
      <title>Merchant Added</title>
      <desc>Created with Sketch.</desc>
      <g id="Case-Details---New">
        <g id="Case-Details---Timeline" transform="translate(-862.000000, -1429.000000)">
          <g id="Timeline" transform="translate(255.000000, 777.000000)">
            <g id="Timeline-Items" transform="translate(277.000000, 107.000000)">
              <g id="Merchant-Attached" transform="translate(317.000000, 528.000000)">
                <g id="Icon">
                  <g id="Avatar">
                    <path
                      id="Shape"
                      fill={fill}
                      d="M22.1,25.7c-0.8,0-1.2,0.5-2.6,0.5s-1.8-0.5-2.6-0.5c-2.2,0-3.9,1.7-3.9,3.8v0.7
                      c0,0.8,0.6,1.4,1.4,1.4h10.2c0.8,0,1.4-0.6,1.4-1.4v-0.7C26,27.4,24.3,25.7,22.1,25.7z M24.6,30.3H14.4v-0.7
                      c0-1.4,1.1-2.5,2.5-2.5c0.4,0,1.1,0.5,2.6,0.5c1.5,0,2.2-0.5,2.6-0.5c1.4,0,2.5,1.1,2.5,2.5V30.3z M19.5,25.2
                      c2.3,0,4.2-1.8,4.2-4.1S21.8,17,19.5,17s-4.2,1.8-4.2,4.1S17.2,25.2,19.5,25.2z M19.5,18.4c1.5,0,2.8,1.2,2.8,2.7
                      s-1.3,2.7-2.8,2.7s-2.8-1.2-2.8-2.7S18,18.4,19.5,18.4z"
                    />
                  </g>
                </g>
              </g>
            </g>
          </g>
        </g>
      </g>
    </svg>
  );
};

export default TimelineMerchantIcon;
